export var breakpointTokens = {
  xxs: 360,
  xs: 475,
  s: 720,
  m: 1020,
  l: 1200,
  xl: 1920
};
export var breakpoint = {
  xxs: "@media (max-width: ".concat(breakpointTokens.xxs, "px)"),
  xs: "@media (max-width: ".concat(breakpointTokens.xs, "px)"),
  s: "@media (max-width: ".concat(breakpointTokens.s, "px)"),
  m: "@media (max-width: ".concat(breakpointTokens.m, "px)"),
  l: "@media (max-width: ".concat(breakpointTokens.l, "px)"),
  xl: "@media (max-width: ".concat(breakpointTokens.xl, "px)")
}; // will standardise these later

export var wrapperBreakpoints = {
  xs: 320,
  // 320 width device, i.e Iphone 5s
  s: 375,
  // Iphone 6/s
  sm: 414,
  // Iphone XR
  m: 667,
  // Iphone 6/s landscape
  l: 768,
  // Ipad landscape
  lg: 991,
  // Magic large
  xl: 1024,
  // Ipad
  xxl: 1199 // Magic x-large

};
export var medias = {
  /**
   * To Width sets
   */
  xsWidth: "@media only screen and (max-width: ".concat(wrapperBreakpoints.xs, "px)"),
  smWidth: "@media only screen and (max-width: ".concat(wrapperBreakpoints.sm, "px)"),

  /**
   * To Landscape sets
   */
  // For content could not fit in small size phone like IPhone 5s / 6 / 6s
  smLandscape: "@media only screen and (orientation: landscape) and (max-height: ".concat(wrapperBreakpoints.sm, "px)"),

  /**
   * To Height sets
   */
  mHeight: "@media screen and (max-height: ".concat(wrapperBreakpoints.m, "px)"),
  lHeight: "@media screen and (max-height: ".concat(wrapperBreakpoints.l, "px)"),
  xlHeight: "@media screen and (max-height: ".concat(wrapperBreakpoints.xl, "px)"),

  /**
   * From sets
   */
  // Very rare device to be handle like Iphone 5s
  beyondSm: "@media only screen and (min-width: ".concat(wrapperBreakpoints.sm + 1, "px) and (min-height: ").concat(wrapperBreakpoints.sm + 1, "px)"),
  beyondM: "@media only screen and (min-width: ".concat(wrapperBreakpoints.m + 1, "px) and (min-height: ").concat(wrapperBreakpoints.m + 1, "px)"),
  // Treat as desktop when screen big than Ipad
  beyondXl: "@media only screen and (min-width: ".concat(wrapperBreakpoints.xl + 1, "px) and (min-height: ").concat(wrapperBreakpoints.l + 1, "px)")
};